<template>
  <div
    class="d-flex flex-column border-default pb-1"
    :class="`${title ? 'pt-1' : ''} ${noBorder ? '' : 'border-b'}`"
  >
    <div
      v-if="title"
      class="d-flex justify-content-between align-items-center px-1 tabTitle"
      :class="disableAdd ? 'disabled-title' : ''"
    >
      <span class="text-md">
        {{ title }}
      </span>
      <button
        v-if="!disableAdd"
        class="btn px-2 btn-outline-primary sidebarButton"
        :disabled="addDisabled"
        @click.prevent="$emit('add')"
      >
        Add
      </button>
    </div>
    <div
      v-if="tabs.length > 0"
      class="d-flex flex-column"
    >
      <div
        v-for="tab in tabs"
        :key="tab.id"
        class="sidebarGroup"
      >
        <div
          class="d-flex justify-content-between align-items-center px-1 rounded py-1 text-md cursor-pointer sidebarTab"
          :class="
            activeTab.id === tab.id && activeChildIndex === null
              ? 'border-primary'
              : 'bg-lt-blue'
          "
          @click="
            () => {
              $emit('selected', tab)
            }
          "
        >
          <span class="text-md text-primary text-break">
            {{ tab.name }} {{ tab.customName ? ` -  ${tab.customName}` : '' }}
          </span>
        </div>
        <div
          v-for="(childTab, index) in tab.childTabs"
          :key="childTab.id"
          class="ml-2 d-flex justify-content-between align-items-center px-1 rounded childTab text-sm cursor-pointer sidebarTab"
          :class="
            activeTab.id === tab.id && activeChildIndex === index
              ? 'border-primary'
              : 'bg-lt-blue'
          "
          @click="
            () => {
              $emit('childSelected', { tab: tab, childTabIndex: index })
            }
          "
        >
          <span class="text-sm text-primary text-break">
            <template v-if="childTab.name || childTab.nameModifier">
              {{ childTab.nameModifier ? `${childTab.nameModifier} - ` : '' }}
              {{ childTab.name ? `${childTab.name}` : '' }}
            </template>
            <template v-else>
              {{ index }}
            </template>
            <!-- {{ childTab.nameModifier ? childTab.nameModifier : childTab.name }} -->
          </span>
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-sm px-1 text-secondary"
    >
      {{ emptyMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobSidebarGroup',
  props: {
    title: {
      type: String,
      default: '',
    },
    tabs: {
      type: Array,
      default: null,
    },
    maxTabs: {
      type: Number,
      default: null,
    },
    activeTab: {
      type: Object,
      default: null,
    },
    emptyMessage: {
      type: String,
      default: '',
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    activeChildIndex: {
      type: Number,
      default: null,
    },
    disableAdd: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    addDisabled() {
      return this.maxTabs ? this.tabs.length === this.maxTabs : false
    },
  },
}
</script>
<style lang="scss" scoped>
.tabTitle.disabled-title {
  margin-top: 7px;
  margin-bottom: 16px;
}
.sidebarGroup {
  margin-bottom: 7px;
}
.sidebarTab {
  border: 1px solid #fff;
  transition: 0.3s;
  margin-bottom: 8px;
  &:hover {
    border: 1px solid #1d79f2 !important;
  }
}
.sidebarButton {
  height: 35px;
}
.bg-lt-blue {
  background: #f1f6fe;
}
.childTab {
  padding-top: 12px;
  padding-bottom: 12px;
}
.tabTitle {
  margin-bottom: 12px;
}
</style>
